export default "__VITE_ASSET__B5dWM1Zy__"